// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA_ZrVOj1oE7BeHJNHzLkTWknDVbrPHe0U",
  authDomain: "propvrty.firebaseapp.com",
  projectId: "propvrty",
  storageBucket: "propvrty.appspot.com",
  messagingSenderId: "717323572606",
  appId: "1:717323572606:web:257878d72d0e944d7dcf2f",
  measurementId: "G-7RQKR0N1RC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const storage = getStorage(app);

export default app;